import { WidgetViewModel } from './WidgetViewModel';
import { EditorDOMUtils } from 'Editor/services/_Common/DOM';
import ReduxInterface from 'Editor/services/ReduxInterface/ReduxInteface';

export class TabBarWidgetModel extends WidgetViewModel<'tabulations'> {
  constructor(
    Visualizer: Editor.Visualizer.State,
    refView: Editor.Visualizer.WidgetDataMapper['tabulations']['view'],
    props: Editor.Visualizer.WidgetDataMapper['tabulations']['props'],
  ) {
    super(Visualizer, refView, props);

    this.container.dataset.type = 'tabulations';
  }

  render(): void {
    let offsets = EditorDOMUtils.getOffsets(this.refView);
    const computedStyle = getComputedStyle(this.refView);
    const parent = this.container.parentElement;
    const zoom = ReduxInterface.getZoomValue() || 1;

    while (this.container.firstChild) {
      this.container.removeChild(this.container.firstChild);
    }

    if (offsets) {
      let marginTop = EditorDOMUtils.convertUnitTo(computedStyle.marginTop, 'px', 'px');
      if (isNaN(marginTop)) {
        marginTop = 0;
      }

      let marginBottom = EditorDOMUtils.convertUnitTo(computedStyle.marginBottom, 'px', 'px');
      if (isNaN(marginBottom)) {
        marginBottom = 0;
      }

      let top = offsets.top - marginTop;
      let height = offsets.height + marginTop + marginBottom;

      this.container.style.position = 'absolute';
      this.container.style.top = `${top}px`;

      if (parent && this.refView) {
        const sectionOrPage = EditorDOMUtils.closestThatMatch(
          this.refView,
          'section-element, [ispagenode="true"]',
        ) as HTMLElement | null;
        const anchorElement = sectionOrPage || this.refView;
        const anchorLeft = anchorElement.getBoundingClientRect().left;
        const parentLeft = parent.getBoundingClientRect().left;
        this.container.style.left = `${(anchorLeft - parentLeft) / zoom}px`;
      }

      this.container.style.width = `0px`;
      this.container.style.height = `${height}px`;
      this.container.style.userSelect = 'none';

      for (let i = 0; i < this.props.tabPos.length; i++) {
        const pos = this.props.tabPos[i];

        const div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.left = `${pos}px`;
        div.style.height = `${height}px`;
        div.style.width = '1px';
        div.style.background = '#000000';
        this.container.appendChild(div);
      }
    }
  }

  dispose(): void {
    this.container.remove();
  }
}
